var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEyeShutIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8504 5.85984C11.2219 5.80643 11.6052 5.77778 12 5.77778C16.6672 5.77778 19.7298 9.78208 20.7587 11.3661C20.8833 11.5578 20.9455 11.6536 20.9804 11.8015C21.0066 11.9125 21.0065 12.0877 20.9803 12.1987C20.9455 12.3466 20.8828 12.4431 20.7574 12.6361C20.4832 13.0579 20.0653 13.6508 19.5115 14.2937M7.17635 7.30226C5.19968 8.60596 3.85775 10.4172 3.24214 11.3647C3.11706 11.5572 3.05451 11.6535 3.01965 11.8013C2.99346 11.9124 2.99345 12.0875 3.01962 12.1985C3.05447 12.3464 3.11673 12.4422 3.24126 12.6339C4.27016 14.2179 7.33276 18.2222 12 18.2222C13.8819 18.2222 15.5029 17.5712 16.8349 16.6903M3.77178 4L20.2282 20M10.0606 10.1144C9.56425 10.597 9.25726 11.2636 9.25726 12C9.25726 13.4728 10.4852 14.6667 12 14.6667C12.7574 14.6667 13.4431 14.3682 13.9394 13.8856",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeShutIcon);
export default __webpack_public_path__ + "static/media/eye_shut_icon.1fdd9d645d89234feefc22dc1a1e9a8f.svg";
export { ForwardRef as ReactComponent };